import request from "@/router/axios"
export const getPermission = (appId) => {
    return request({
        url: `/api/sys/appInfo/getPermission`,
        method: 'get',
        params: {
            appId
        }
    })
}
export const setPermission = (appId, apiIds) => {
    return request({
        url: `/api/sys/appInfo/setPermission`,
        method: 'post',
        params: {
            appId,
            apiIds
        }
    })
}
export const list = () => {
    return request({
        url: `/api/sys/appInfo/list`,
        method: 'post',
        data: {
            filterParams: [{
                name: "isValid",
                value: true
            }],
            orderBy: "name",
            isDesc: false
        }
    })
}